import request from '@/api/request'

//  推荐人管理页面 推荐人用户数据保存
export const refereeUserAdd = (data,params) => {
    return request({
        url: '/referee-user/addBatch',
        method: 'POST',
        data:data,
        params:params
    })
}